<fu-icon [iconName]="iconName()" [size]="numberSize()" />
